import {AttributeDescriptor, BaseModel, BaseModelDescriptor} from "./BaseModel";
import {ValidationTypes} from "../core/Validator";
import {User} from "./User";
import {FormatTypes} from "../core/Formater";

export class Employee extends BaseModel {
	id: string
    firstName: string
    lastName: string
	positionId: string
	birthDate: string
	address: string
	phone: string
	personalId: number
	insuranceId: number
	educationLevel: educationLevelTypes
	contractType: contractTypes
	contractEndDate: string
	userId: User
}

export class EmployeeDescriptor extends BaseModelDescriptor{
	static id: AttributeDescriptor = {validation: []}
	static firstName: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static lastName: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static positionId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED]}
	static birthDate: AttributeDescriptor = {validation: [], format: FormatTypes.DATE}
	static address: AttributeDescriptor = {validation: []}
	static phone: AttributeDescriptor = {validation: []}
	static personalId: AttributeDescriptor = {validation: [ValidationTypes.REQUIRED, ValidationTypes.NUMERIC, ValidationTypes.PERSONAL_ID]}
	static insuranceId: AttributeDescriptor = {validation: []}
	static contractEndDate: AttributeDescriptor = {validation: [], format: FormatTypes.DATE}
}

export enum contractTypes {
	EMPLOYED_ON_AN_INDETERMINANTE_PERIOD = 'Radni odnos na neodredjeno vreme',
	EMPLOYED_ON_LIMITED_TIME_DURATION = 'Radni odnos na odredjeno vreme',
	EMPLOYED_ON_CONTRACT = 'Rad po ugovoru'
}

export enum educationLevelTypes {
	O_1 = 'Osnovno obrazovanje i vaspitanje (NOKS nivo 1)',
	S_2 = 'Stručno osposobljavanje u trajanju 1 ili 2 godine (NOKS nivo 2)',
	S_3 = 'Srednje stručno obrazovanje u trajanju od 3 godine (NOKS nivo 3)',
	S_4 = 'Srednje obrazovanje u trajanju od 4 godine (NOKS nivo 4)',
	M_5 = 'Majstorsko i specijalističko obrazovanje (NOKS nivo 5)',
	OS_6_1= 'Osnovne studije 180 ESPB (NOKS nivo 6.1)',
	OS_6_2= 'Osnovne studije 240 ESPB (NOKS nivo 6.2)',
	MS_7_1= 'Master studije 300 ESPB (NOKS nivo 7.1)',
	SS_7_2= 'Specijalističke akademske studije (NOKS nivo 7.2)',
	D_8= 'Doktorske studije (NOKS nivo 8)'
}
